"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ZoomRoomApplianceFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ZoomRoomApplianceFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 0a1.75 1.75 0 1 0 0 3.5h10.5a1.75 1.75 0 1 0 0-3.5H2.75ZM8 2.25a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.136 10.682C8 10.95 8 11.3 8 12v2c0 .7 0 1.05.136 1.318.12.235.311.426.547.546C8.95 16 9.3 16 10 16h4c.7 0 1.05 0 1.318-.136a1.25 1.25 0 0 0 .546-.546C16 15.05 16 14.7 16 14v-2c0-.7 0-1.05-.136-1.318a1.25 1.25 0 0 0-.546-.546C15.05 10 14.7 10 14 10h-4c-.7 0-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3.38a2.253 2.253 0 0 0-.229-.135 2.28 2.28 0 0 0-.869-.225c-.25-.02-.547-.02-.868-.02H9.966c-.32 0-.619 0-.868.02a2.28 2.28 0 0 0-.87.225 2.25 2.25 0 0 0-.983.984 2.28 2.28 0 0 0-.225.869c-.02.25-.02.547-.02.868v2.068c0 .32 0 .619.02.868l.01.098H2a2 2 0 0 1-2-2V6Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ZoomRoomApplianceFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ZoomRoomApplianceFill;
exports["default"] = _default;